import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../../atoms/button/Button";
import { goToEntryPricingSection } from "../../goToEntryPricingSection";

interface NavBarContactButtonProps {
  contactAction?: () => void;
  contactText?: string;
}

const NavBarContactButton: React.FC<NavBarContactButtonProps> = ({
  contactAction,
  contactText = "Entrer Dans l'App",
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleContactClick = () => {
    if (contactAction) {
      contactAction();
    } else {
      goToEntryPricingSection(pathname, navigate);
    }
  };

  return (
    <div className="flex h-full w-1/2 items-center justify-end laptop:w-2/12">
      <Button type="button" expandWidth onClick={handleContactClick} className="!mt-0">
        {contactText}
      </Button>
    </div>
  );
};

export default NavBarContactButton;
